import { useState } from "react";
import clsx from "clsx";
import { Link, Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MenteeIcon from "@images/logoLight.png";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function BoxBar() {
  const [showHamburger, setShowHamburger] = useState(false);
  const { activeLink } = useSelector((state) => state.admin);

  const links = [
    { name: "Users", path: "/users" },
    { name: "Community", path: "/communities" },
    { name: "Groups", path: "/groups" },
    { name: "Reports", path: "/reports" },
    { name: "Settings", path: "/settings" },
    { name: "Logout", path: "/logout" },
  ];
  const navigate = useNavigate();
  const { userRecord } = useSelector((state) => state.user);
  console.log("--------------------------------");

  const roles = userRecord?.role || userRecord?.roles || [];

  const roleArray = Array.isArray(roles)
    ? roles.map((r) => r.toUpperCase().trim())
    : [roles.toString().toUpperCase().trim()];

  const isCommunityAdmin = roleArray.includes("COMMUNITYADMIN");
  const isSuperAdmin = roleArray.includes("ADMIN");

  console.log("isCommunityAdmin:", isCommunityAdmin);
  console.log("isSuperAdmin:", isSuperAdmin);

  const basePath =
    !isSuperAdmin && isCommunityAdmin ? "/community-admin" : "/admin";

  console.log("basePath:", basePath);

  return (
    <Box bgcolor="primary.main" className="py-4">
      <div className="mx-auto flex flex-wrap items-center justify-between p-4">
        <a
          href="/admin"
          className="flex items-center space-x-3 rtl:space-x-reverse ml-6"
        >
          <img src={MenteeIcon} width={150} alt="Logo" />
        </a>
        <div className="md:hidden">
          <IconButton onClick={() => setShowHamburger(!showHamburger)}>
            <MenuIcon sx={{ color: "primary.contrastText" }} />
          </IconButton>
        </div>

        <div
          className={clsx(
            "w-full md:m-auto md:block md:w-auto	",
            showHamburger ? "block" : "hidden"
          )}
        >
          <ul className="mt-4 flex flex-col gap-6 rounded-lg md:mt-0 md:flex-row md:space-x-8 md:border-0 md:p-0 ">
            {links.map((link, key) => (
              <li key={key}>
                <Link
                  onClick={() => navigate(basePath + link.path)}
                  sx={{ borderColor: "primary.contrastText" }}
                  underline="none"
                  className={clsx(
                    activeLink === key && "md:border-b-4",
                    "md:hover:border-b-4",
                    "py-2 cursor-pointer mr-4 font-medium"
                  )}
                  color="primary.contrastText"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Box>
  );
}
